<template>
  <div>
    <Header v-if="this.userInfo.user.permission == 'super_admin'" />
    <HodHeader v-if="this.userInfo.user.permission == 'hod'" />
    <CoordinateHeader v-if="this.userInfo.user.permission == 'co-ordinator'" />
    <InstructorHeader v-if="this.userInfo.user.permission == 'instructor'" />

    <confirmPopup
      v-if="popupwindow == true"
      :title="titlepass"
      @cancelClick="popupwindow = false"
      @confirmClick="deletecourse(idpass)"
    />

    <div class="py-3">
      <div class="container mx-auto max-w-[1200px] px-6 md:px-10 mt-10 mb-10">
        <div class="flex flex-col gap-5">
          <div class="flex items-center justify-between">
            <router-link
              :to="{ name: 'HodSemesters', params: { batch: this.batch } }"
              class="cursor-pointer bg-blues hover:bg-blue-600 text-white px-3 py-1 text-sm font-bold rounded-2xl"
            >
              Back
            </router-link>

            <!-- <p @click="this.currentSemesterData = null"
                  class="bg-primary text-white px-6 mt-4 py-1.5 rounded-full text-sm text-center cursor-pointer"
                >
                  Back
                </p>   -->

            <!-- <div v-if="this.userInfo.user.permission != 'instructor'" @click="addCourse = true" class="bg-primary text-sm text-white px-6 mt-4 py-1.5 rounded-full text-center cursor-pointer flex items-center justify-center">
                Add New Course
                </div> -->
          </div>

          <h1 class="text-primary text-xl font-bold">Courses</h1>

          <div class="">
            <template class="text-center" v-if="loading"> Loading... </template>

            <div
              v-else
              class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-5"
            >
              <template class="text-center" v-if="courseList.length == 0">
                No Courses
              </template>

              <div
                v-for="course in courseList"
                :key="course"
                class="rounded-3xl shadow-md"
              >
                <div
                  class="flex flex-col h-full justify-between text-start sm:text-left px-4 sm:px-6 py-6"
                >
                  <router-link
                    :to="{
                      name: 'InstructorStudents',
                      params: {
                        course_id: course.id,
                        department_id: course.department.id,
                      },
                    }"
                    class="flex flex-col gap-1 min-h-[300px]"
                  >
                    <img
                      v-if="course.thumbnail"
                      class="object-cover object-center h-[200px] w-full rounded-lg"
                      :src="course.thumbnail"
                      alt="Course Thumbnail"
                    />
                    <img
                      v-else
                      class="object-cover object-center h-[200px] w-full rounded-lg"
                      src="@/assets/coding.svg"
                      alt="Default Thumbnail"
                    />

                    <h1 class="font-bold text-lg lg:text-lg prime text-left">
                      {{ course.title.slice(0, 70) }}
                      <span v-if="course.title.length > 70">...</span>
                    </h1>

                    <div class="flex flex-col gap-1">
                      <p class="text-sm">
                        <span class="font-semibold">Course Code:</span>
                        {{ course?.course_code || "NAN" }}
                      </p>
                      <p class="text-sm">
                        <span class="font-semibold">Program:</span>
                        {{ course?.program?.name || "NAN" }}
                      </p>
                      <p class="text-sm">
                        <span class="font-semibold">Semester: </span
                        >{{ course?.semester?.semester || "NAN" }}
                      </p>
                      <!-- <p class="text-sm">
                        <span class="font-semibold">Sections:</span>
                        {{ course.sections.length }}
                      </p> -->
                      <p class="text-sm">
                        <span class="font-semibold">Section:</span>
                        {{ course?.class_section || "NAN" }}
                      </p>

                      <!-- <p class="text-sm">
                        <span class="font-semibold">Department: </span
                        >{{ course?.department?.name || "NAN" }}
                      </p> -->

                      <!-- <p class="text-sm">
                        <span class="font-semibold">Instructor Email:</span>
                        <span v-if="course.instructor.length > 0">
                          {{ course?.instructor[0].user.email }}
                        </span>
                        <span v-else>NAN</span>
                      </p> -->

                      <p class="text-sm">
                        <span class="font-semibold">Course Type:</span>
                        {{ course?.course_type?.title || "NAN" }}
                      </p>
                      <p class="text-sm">
                        <span class="font-semibold">Instructor Name:</span>
                        <span v-if="course.instructor.length > 0">
                          {{ course.instructor[0].user.display_name }}
                        </span>
                        <span v-else>NAN</span>
                      </p>
                      <p class="text-sm">
                        <span class="font-semibold">Publish:</span>
                        {{
                          course?.is_published === true
                            ? "Published"
                            : course?.is_published === false
                            ? "Unpublished"
                            : "NA"
                        }}
                      </p>
                      <p class="text-sm">
                        <span class="font-semibold">Student Count:</span>
                        {{ course?.student_count || 0 }}
                      </p>
                    </div>
                  </router-link>

                  <div
                    class="mb-5 mt-2 flex items-center gap-2 hidden"
                    v-if="
                      this.userInfo.user.permission == 'super_admin' ||
                      this.userInfo.user.permission == 'hod' ||
                      this.userInfo.user.permission == 'co-ordinator'
                    "
                  >
                    <button
                      @click="changeInstructorPopup = course.id"
                      class="text-xs cursor-pointer bg-blues text-white px-3 py-1 font-bold rounded-2xl transition-colors duration-200 hover:bg-blue-100 hover:text-black hover:border-blues border border-transparent"
                    >
                      Change Instructor
                    </button>

                    <!--  -->
                    <router-link
                      :to="{
                        name: 'InstructorStudents',
                        params: {
                          course_id: course.id,
                          department_id: course.department.id,
                        },
                      }"
                      class="text-xs cursor-pointer bg-blues text-white px-3 py-1 font-bold rounded-2xl transition-colors duration-200 hover:bg-blue-100 hover:text-black hover:border-blues border border-transparent"
                    >
                      Dashboard
                    </router-link>
                  </div>

                  <div class="flex items-center gap-10 mt-5">
                    <router-link
                      :to="{
                        name: 'AddLessonUnitForBatch',
                        params: {
                          course_id: course.id,
                          batch: this.batch,
                          semester: this.semester,
                        },
                      }"
                      class="flex flex-col gap-1"
                    >
                      <div>
                        <img
                          src="@/assets/newd/icon1.svg"
                          alt="Add Course"
                          class="cursor-pointer"
                        />
                      </div>
                    </router-link>

                    <router-link
                      v-if="
                        this.userInfo.user.permission == 'super_admin' ||
                        this.userInfo.user.permission == 'hod' ||
                        this.userInfo.user.permission == 'co-ordinator'
                      "
                      :to="{
                        name: 'EditCourseForBatch',
                        params: {
                          course_id: course.id,
                          batch: this.batch,
                          semester: this.semester,
                        },
                      }"
                      class="flex flex-col gap-1"
                    >
                      <div>
                        <img src="@/assets/newd/icon2.svg" alt="Edit Course" />
                      </div>
                    </router-link>

                    <!-- <div @click="addLessonUnitPopup = true; currentId = course.id"
                        >
                          <img src="@/assets/newd/icon1.svg" alt="Add Course" />
                        </div> -->

                    <div
                      v-if="this.userInfo.user.permission != 'instructor'"
                      @click="
                        titlepass = course.title;
                        popupwindow = true;
                        idpass = course.id;
                      "
                      class="cursor-pointer"
                    >
                      <img src="@/assets/newd/icon3.svg" alt="Delete Course" />
                    </div>

                    <router-link
                      :to="{
                        name: 'HodCoursePreview',
                        params: {
                          course: course.id,
                          semester: this.semester,
                          batch: this.batch,
                        },
                      }"
                      class="cursor-pointer bg-blues hover:bg-blue-600 text-white px-3 py-1 text-sm font-bold rounded-2xl"
                    >
                      Preview
                    </router-link>
                  </div>

                  <!-- <router-link
                        :to="{
                          name: 'InstructorStudents',
                          params: { course_id: course.id },
                        }"
                        class="relative cursor-pointer bg-primary text-white px-3 py-1.5 my-5 text-sm text-center font-bold rounded-2xl"
                      >
                        Dashboard
                      </router-link> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="addCourse"
      class="fixed w-[100%] h-[100%] bg-gray-500 bg-opacity-50 left-0 right-0 top-0 bottom-0 flex items-center justify-center"
    >
      <NewCourse
        :batchYear="this.batch"
        :departmentName="currentSemesterData.department.id"
        :programName="currentSemesterData.department.program.id"
        :semesterName="currentSemesterData.id"
        @close-Emit="closeReciveEmit"
      />
    </div>

    <div
      v-if="editCoursePopup"
      class="fixed w-[100%] h-[100%] bg-gray-500 bg-opacity-50 left-0 right-0 top-0 bottom-0 flex items-center justify-center"
    >
      <EditCourse
        :course_id="currentId"
        :batchYear="currentBatchData.year"
        :departmentName="currentSemesterData.department.name"
        :programName="currentSemesterData.department.program.name"
        :semesterName="currentSemesterData.semester"
        @close-EmitEdit="closeReciveEmitEdit"
      />
    </div>

    <div
      v-if="addLessonUnitPopup"
      class="fixed z-50 w-[100%] h-[100%] bg-gray-500 bg-opacity-50 left-0 right-0 top-0 bottom-0"
    >
      <AddLessonUnit
        :course_id="currentId"
        @close-AddUnit="closeReciveEmitAddUnit"
      />
    </div>

    <div
      v-if="changeInstructorPopup != null"
      class="fixed z-50 w-[100%] h-[100%] bg-gray-500 bg-opacity-50 left-0 right-0 top-0 bottom-0 flex justify-center items-center"
    >
      <div
        class="container px-6 mx-auto max-w-[1200px] flex flex-col gap-10 my-10 pb-10"
      >
        <div class="pb-10">
          <form
            ref="changeInsRef"
            @submit.prevent="completeUnitStart"
            class="rounded-3xl py-10 px-10 pb-2 heightfix bg-white overflow-y-auto flex flex-col gap-5"
            style="box-shadow: 0px 2px 20px 0px #105c8e26"
          >
            <div class="flex items-center justify-end gap-4">
              <button
                @click="changeInstructorPopup = null"
                class="bg-blues text-xs font-bold text-white px-5 py-1.5 rounded-full cursor-pointer"
              >
                Close
              </button>
            </div>

            <div class="flex flex-col gap-3">
              <label class="text-sm">Select Faculty </label>
              <select
                id="instructor"
                class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3"
              >
                <option value="" disabled>Select Faculty</option>
                <option
                  v-for="instructor in instructor_lists"
                  :key="instructor.id"
                  :value="instructor.id"
                >
                  {{ instructor.user.email }}
                </option>
              </select>
            </div>

            <div class="pb-8 flex items-center gap-3">
              <button
                type="submit"
                :disabled="disable_submit == true"
                :class="
                  this.disable_submit == true
                    ? 'bg-gray-200 text-black cursor-not-allowed'
                    : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white'
                "
                class="rounded-lg text-sm px-4 py-2"
              >
                Submit
              </button>
              <img
                v-if="disable_submit"
                src="@/assets/loading.gif"
                alt="loading"
                class="w-6 h-6 object-contain"
              />-->
            </div>
          </form>
        </div>
      </div>
      <!-- <AddLessonUnit
        :course_id="currentId"
        @close-AddUnit="closeReciveEmitAddUnit"
      /> -->
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Admin/Header.vue";
import HodHeader from "@/components/Hod/Header.vue";
import CoordinateHeader from "@/components/Coordinate/Header.vue";
import InstructorHeader from "@/components/Instructor/Header.vue";

import Footer from "@/components/Footer.vue";
import { mapGetters } from "vuex";

import axios from "axios";

import NewCourse from "./NewCourse.vue";
import ConfirmPopup from "@/components/ConfirmPopup.vue";
import EditCourse from "./EditCourse.vue";
import AddLessonUnit from "@/components/Common/AddLessonUnit.vue";

export default {
  components: {
    HodHeader,
    CoordinateHeader,
    Header,
    InstructorHeader,
    Footer,
    NewCourse,
    ConfirmPopup,
    EditCourse,
    AddLessonUnit,
  },
  computed: mapGetters(["userInfo"]),

  props: ["semester", "batch"],

  data() {
    return {
      changeInstructorPopup: null,
      batchList: [],
      currentBatchData: null,
      semeterList: [],
      currentSemesterData: null,
      courseList: [],
      currentTab: "",
      semesterId: null,
      addCourse: false,
      popupwindow: false,
      editCoursePopup: false,
      currentId: null,
      addLessonUnitPopup: false,
      loading: false,
      instructor_lists: [],
      disable_submit: false,
    };
  },

  created() {
    // this.getBatchList();
    this.getDetailGet();
    this.getSemesterCourses(this.semester);
    this.getInstructorList();
  },

  methods: {
    async completeUnitStart() {
      this.disable_submit = true;
      console.log(document.getElementById("instructor").value);
      const instructorId = Number(document.getElementById("instructor").value);

      await axios
        .put(
          `${process.env.VUE_APP_API}/categoryinstructorupdate/${this.changeInstructorPopup}/?Key=${this.userInfo.token_key}`,
          {
            id: this.changeInstructorPopup,
            instructor: [instructorId],
          },
        )
        .then((response) => {
          if (response.data.status == "200") {
            this.messages = {
              text: "Instructor Changed Successfully.",
              type: "success",
            };
            setTimeout(() => {
              this.$refs.changeInsRef.reset();
              this.getSemesterCourses(this.semester);
              this.changeInstructorPopup = null;
              this.messages = {
                text: "",
                type: "",
              };
            }, 2000);
          } else {
            this.messages = {
              text: "Error Issue.",
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "",
              };
            }, 2000);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.disable_submit = false;
        });
    },
    getInstructorList() {
      axios
        .get(
          `${process.env.VUE_APP_API}/instructor_all/?Key=${this.userInfo.token_key}`,
        )
        .then((res) => {
          console.log(res);
          this.instructor_lists = res.data.products;
        });
    },

    getDetailGet() {
      axios
        .get(
          `${process.env.VUE_APP_API}/semetser-get/?Key=${this.userInfo.token_key}&id=${this.semester}`,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.currentSemesterData = response.data.data[0];
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    closeReciveEmitAddUnit() {
      this.addLessonUnitPopup = false;
      this.getSemesterCourses(this.semester);
    },

    closeReciveEmitEdit() {
      this.editCoursePopup = false;
      this.getSemesterCourses(this.semester);
    },

    async deletecourse(data) {
      await axios
        .delete(
          `${process.env.VUE_APP_API}/courseupdate/${data}/?Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          this.res = response;
          if (this.res.statusText == "No Content") {
            this.messages = {
              text: "Deleted successfully",
              type: "success",
            };
            this.getSemesterCourses(this.semester);
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
        });
      this.popupwindow = false;

      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
      }, 2000);
    },

    closeReciveEmit() {
      this.addCourse = false;
      this.getSemesterCourses(this.semester);
    },

    getSemesterCourses(id) {
      this.loading = true;
      axios
        .get(
          `${process.env.VUE_APP_API}/hod/course-list/${id}/?Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          this.loading = false;
          if (response.data.status == 200) {
            this.courseList = response.data.data;
            this.loading = false;
          } else {
            this.loading = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style></style>
